import { render, staticRenderFns } from "./ViewImages.vue?vue&type=template&id=3ee48664&scoped=true&"
import script from "./ViewImages.vue?vue&type=script&lang=js&"
export * from "./ViewImages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee48664",
  null
  
)

export default component.exports